<div class="otp-info-message" [style]="{backgroundColor: infoMessage.bgColor}" *ngIf="displayInfoMessage">
    <div class="info-icon"><i [class]="infoMessage.icon" ></i></div>
    <div class="info-content">{{ infoMessage.message }}</div>
</div>

<div class="authentication-container">
  <div class="hero-section">
    <div class="header">
      <div class="neo-hire-icon">
        <img src="./assets/icons-svg/neo-hire.svg" />
      </div>
      <div class="neo-hire-details">
        <h3 class="title">Hire Smarter. Hire Faster. Powered by AI.</h3>
        <span class="subtitle">
          Our platform combines speed, precision, automation to help you find the right candidates
          in less time, with better outcomes. our AI ensures you hire top talent quickly, efficiently, and
          confidently.
        </span>
      </div>
      <app-authentication-carousel></app-authentication-carousel>
    </div>
    <div class="footer">
        <img src="./assets/icons-svg/star.svg" />
        Trusted by high-growth teams to scale hiring efficiently
        <img src="./assets/icons-svg/star.svg" />
    </div>
  </div>
  <div class="form-section">
    <div class="company-logo" (click)="goBack()" *ngIf="!resetPasswordState">
      <i class="pi pi-arrow-left"></i>
    </div>
    <div class="form-container" *ngIf="!resetPasswordState">
      <div class="login-details">
        <h3 class="title">Forgot Password</h3>
        <span class="subtitle">
          A link will be sent to your email to help reset password.
        </span>
      </div>

      <div class="login-form">
        <div class="form">
          <div class="neo-input-wrapper">
            <div class="opt-resend-label">
                <label for="email">Email Address</label>
                <ng-container *ngIf="!resetPasswordState && showResendLink">
                    <a class="resend-link" *ngIf="!waitToResend" (click)="!waitToResend && sendResetLinkByEmail()">
                        Resend Code
                    </a>
                    <span *ngIf="waitToResend" style="cursor: auto;" class="resend-link">
                        Resend in {{countdown}}s
                    </span>
                </ng-container>
            </div>
            <input pInputText type="email" name="email" id="forgot_password_email" placeholder="Enter your email address"
              [(ngModel)]="emailToVerify" [pattern]="emailPattern" [required]="true" #resetLinkEmail="ngModel" class="lg" />
          </div>
        </div>
        <button pButton class="neo-btn" id="forgot_password_send_reset_link" [loading]="btnLoading" (click)="sendResetLinkByEmail()" (keydown)="sendResetLinkByEmail()" [disabled]="!resetLinkEmail?.valid || waitToResend">Send Reset Link</button>
      </div>
    </div>
    <div class="form-container" *ngIf="resetPasswordState">
        <div class="login-details">
            <h3 class="title">Create New Password</h3>
            <span class="subtitle">
                The password should be different from the previous password.
            </span>
        </div>

        <div class="login-form" [formGroup]="passwordForm">
            <div class="form">
                <div class="password-input-wrapper">
                    <div class="neo-input-wrapper">
                        <label for="forgot_password_new_password" required>New Password</label>
                        <input pInputText type="password" name="newPassword" id="forgot_password_new_password" formControlName="newPassword"
                            placeholder="Enter your new password" class="lg">
                    </div>
                    <div class="level-indicator" [class.medium]="passwordLevel.level == 2" [class.good]="passwordLevel.level >= 3">
                        {{passwordLevel.level === 2 ? "Medium" : (passwordLevel.level >= 3 ? "Good" : "Weak") }}
                        <div class="indicators">
                            <div class="indicator" [class.active]="passwordLevel.level >= 1 || passwordForm.get('newPassword')?.value?.length" [class.medium]="passwordLevel.level == 2"
                                [class.good]="passwordLevel.level >= 3"></div>
                            <div class="indicator" [class.active]="passwordLevel.level >= 2" [class.medium]="passwordLevel.level == 2"
                                [class.good]="passwordLevel.level >= 3"></div>
                            <div class="indicator" [class.active]="passwordLevel.level >= 3" [class.medium]="passwordLevel.level == 2"
                                [class.good]="passwordLevel.level >= 3"></div>
                        </div>
                    </div>
                    <div class="password-helper">
                        <div class="password-helper-item">
                            <div class="indicator" [class.invalid]="!passwordLevel.hasMinLength" [class.valid]="passwordLevel.hasMinLength">
                                <img src="./assets/icons-svg/check.svg" />
                            </div>
                            <span [class.invalid-helper]="!passwordLevel.hasMinLength" [class.active-helper]="passwordLevel.hasMinLength">
                                Be at least 8 characters long.
                            </span>
                        </div>
                        <div class="password-helper-item">
                            <div class="indicator" [class.invalid]="!passwordLevel.hasUpperCase" [class.valid]="passwordLevel.hasUpperCase">
                                <img src="./assets/icons-svg/check.svg" />
                            </div>
                            <span [class.invalid-helper]="!passwordLevel.hasUpperCase" [class.active-helper]="passwordLevel.hasUpperCase">
                                At least one uppercase letter (A-Z).
                            </span>
                        </div>
                        <div class="password-helper-item">
                            <div class="indicator" [class.invalid]="!passwordLevel.hasSpecialCharacter" [class.valid]="passwordLevel.hasSpecialCharacter">
                                <img src="./assets/icons-svg/check.svg" />
                            </div>
                            <span [class.invalid-helper]="!passwordLevel.hasSpecialCharacter"
                                [class.active-helper]="passwordLevel.hasSpecialCharacter">
                                {{'At least one special characters (! @ # $ % ^ & * %).'}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="neo-input-wrapper">
                    <label for="forgot_password_new_password_confirm" required>Confirm Password</label>
                    <span style="position: relative;">
                        <input pInputText [type]="confirmPassShow ? 'text' : 'password'" name="confirmPassword" id="forgot_password_new_password_confirm" formControlName="confirmPassword"
                            placeholder="Reenter your password" style="padding-right: 34px !important;" class="lg">
                        <span class="inputEmailIcon">
                            <em *ngIf="!this.confirmPassShow"
                                (click)="this.confirmPassShow = !this.confirmPassShow"
                                class="pi pi-eye"></em>
                            <em *ngIf="this.confirmPassShow"
                                (click)="this.confirmPassShow = !this.confirmPassShow"
                                class="pi pi-eye-slash"></em>
                        </span>
                    </span>
                    <div *ngIf="passwordForm.get('confirmPassword')?.errors?.['mismatch'] && passwordForm.get('newPassword')?.value && passwordForm.get('confirmPassword')?.value; else checksamepass" style="color: #E24A47; font-size: 12px; margin-top: 5px;">
                        Password do not match
                    </div>
                    <ng-template #checksamepass>
                        <div *ngIf="passwordForm.get('newPassword')?.value && passwordForm.get('currentPassword')?.value && passwordForm.get('newPassword')?.value === passwordForm.get('currentPassword')?.value" style="color: #E24A47; font-size: 12px; margin-top: 5px;">
                            Current and New Password cannot be same
                        </div>
                    </ng-template>
                </div>
            </div>

            <button pButton class="neo-btn" id="forgot_password_reset_password" [loading]="btnLoading" (click)="confirm()" [disabled]="passwordForm.invalid || btnLoading">
                Reset Password
            </button>
        </div>
    </div>
  </div>
</div>


@if (false) {
<div class="otp-info-message" [style]="{backgroundColor: infoMessage.bgColor}" *ngIf="displayInfoMessage">
    <div class="info-icon"><i [class]="infoMessage.icon" ></i></div>
    <div class="info-content">{{ infoMessage.message }}</div>
</div>
<div class="opt-verification" *ngIf="!resetPasswordState">
    <div class="opt-popup">
        <div class="otp-container">
            <p class="otp-header mt-40" *ngIf="!pageLoading">
                <span *ngIf="sendResetLinkState">Email Verification</span>
            </p>
            <span class="email-field mt-40" style="width: 100%;margin: 30px 0 0;" *ngIf="!pageLoading">
                <div class="p-float-label">
                    <input [(ngModel)]="emailToVerify" class="inputEmail" type="email" id="inputtext" [pattern]="emailPattern" [required]="true" #resetLinkEmail="ngModel" pInputText/>
                    <label for="inputtext">Email ID<span class="imp">*</span></label>
                </div>
            </span>
            <div class="resend-container" *ngIf="!resetPasswordState && showResendLink">
                <div class="resend-info">
                    <span 
                        [class.disabled]="waitToResend" 
                        (click)="!waitToResend && sendResetLinkByEmail()" 
                        class="resent-btn" 
                        style="cursor: pointer;">
                        <ng-container *ngIf="!waitToResend">
                            Resend <strong>Reset Link</strong>
                        </ng-container>
                        <ng-container *ngIf="waitToResend">
                            Resend in <strong>{{ countdown }}s</strong>
                        </ng-container>
                    </span>
                </div>
            </div>
            <div *ngIf="sendResetLinkState && !pageLoading" class="card flex justify-content-center submit-btn mt-40" style="width: 100%; margin-top: 30px;">
                <p-button label="Send Reset Link" [ngClass]="{'disabled': !resetLinkEmail?.valid || waitToResend}" [loading]="btnLoading" (click)="sendResetLinkByEmail()" (keydown)="sendResetLinkByEmail()" [disabled]="!resetLinkEmail?.valid || waitToResend"></p-button>
            </div>
            <p-progressSpinner *ngIf="pageLoading" [style]="{height: '30px', width: '30px'}" strokeWidth="7"
                animationDuration="0.5s">
            </p-progressSpinner>
        </div>
    </div>
</div>
<div class="reset_password-container" *ngIf="resetPasswordState">
    <div class="reset_password-card">
        <div class="reset_password-popup">
            <p class="reset_password-header mt-40" *ngIf="!pageLoading && !redirecting">
                <span>Reset Password</span>
            </p>
            <span class="password-fields mt-40" style="width: 100%;margin: 30px 0 0;" *ngIf="!pageLoading && !redirecting">

                <form [formGroup]="passwordForm">
                    <span class="p-float-label" [style]="{display: 'flex', alignItems: 'center'}"> 
                        <input type="password" class="inputtext newPasswordInput" id="inputtext" pInputText formControlName="newPassword"
                            [ngClass]="{'invalid': clicked && passwordForm.controls['newPassword'].errors}">
                        <span *ngIf="!showNewPassword" class="eye-icon pi pi-eye" (click)="showToggle('newPasswordInput', 'newPassword')" (keydown)="showToggle('newPasswordInput', 'newPassword')"></span>
                        <span *ngIf="showNewPassword" class="eye-icon pi pi-eye-slash" (click)="showToggle('newPasswordInput', 'newPassword')" (keydown)="showToggle('newPasswordInput', 'newPassword')"></span>
                        <label for="inputtext">New Password <span [style]="{color: '#E24A47'}">*</span></label>
                    </span>

                    <span class="p-float-label" [style]="{display: 'flex', alignItems: 'center'}">
                        <input type="password" class="inputtext confirmPasswordInput" id="inputtext" pInputText formControlName="confirmPassword"
                            [ngClass]="{'invalid': clicked && passwordForm.controls['confirmPassword'].errors}" (paste)="false">
                        <span *ngIf="!showConfirmPassword" class="eye-icon pi pi-eye" (click)="showToggle('confirmPasswordInput', 'confirmPassword')" (keydown)="showToggle('confirmPasswordInput', 'confirmPassword')"></span>
                        <span *ngIf="showConfirmPassword" class="eye-icon pi pi-eye-slash" (click)="showToggle('confirmPasswordInput', 'confirmPassword')" (keydown)="showToggle('confirmPasswordInput', 'confirmPassword')"></span>
                        <label for="inputtext">Confirm Password <span [style]="{color: '#E24A47'}">*</span></label>

                    </span>
                    <div class="passwrod-error" *ngIf="passwordForm?.hasError('mismatch') && (passwordForm.get('newPassword')?.touched && passwordForm.get('confirmPassword')?.touched)">
                        Passwords do not match.
                    </div>
                    
                    <div class="passwrod-error" *ngIf="passwordForm.get('newPassword')?.hasError('pattern') && passwordForm.get('newPassword')?.touched">
                        Password must contain a Lowercase, Uppercase, Number, Special character and must be alteast 8 characters
                    </div>
                    <div class="card flex justify-content-center submit-btn mt-40" style="width: 96%; margin-top: 30px;">
                        <p-button label="Reset" (onClick)="confirm()" [loading]="btnLoading" [ngClass]="{'disabled': passwordForm.invalid}" ></p-button>
                    </div>
                    
                </form>
            </span>
            <span *ngIf="redirecting">
                <p class="otp-header mt-40">Password Reset Successfully!</p>
                <div [style]="{display: 'flex', alignItems: 'center', margin: '30px 0', justifyContent: 'center'}">
                    <p>Redirecting to login page...</p>
                    <p-progressSpinner  [style]="{height: '24px', width: '24px'}" strokeWidth="7"
                        animationDuration="0.5s">
                    </p-progressSpinner>
                </div>
            </span>
        </div>
    </div>
</div>
}

<p-confirmDialog [style]="{width: '30vw'}" header="Confirmation" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text"></p-confirmDialog>
<p-toast></p-toast>